export async function GetPatientSummary({ state, actions ,emailData}) {
    const { triageRequest } = state
    const { sessionId } = triageRequest
    const encounterToken = localStorage.getItem('token')
    const data = {
        identifier: sessionId,
        token: encounterToken,
        Email:emailData
       
    }
}